export default __webpack_public_path__ + "static/media/0001.f731af66.jpg";